import { PanelCard, PanelCardHead } from "./PanelCard"

// The shared not-ready / empty state every data panel falls back to when there's
// nothing to show yet (design prototype `.estate` — see order-states.html §4).
// The panel supplies the card head (Icon + title); this draws the centered glyph,
// heading, copy and an optional action.
export default function PanelEmpty({ Icon, title, heading, body, action, headExtra }) {
  return (
    <PanelCard>
      <PanelCardHead Icon={Icon} title={title}>
        {headExtra}
      </PanelCardHead>
      <div className="flex flex-col items-center justify-center px-8 py-16 text-center">
        <span className="grid size-14 place-items-center rounded-2xl border border-border bg-accent text-ink-3">
          <Icon className="size-7" strokeWidth={1.6} />
        </span>
        <h4 className="mt-4 font-display text-[16px] font-bold">{heading}</h4>
        <p className="mt-1.5 max-w-[440px] text-[13px] leading-[1.6] text-muted-foreground">{body}</p>
        {action && <div className="mt-5">{action}</div>}
      </div>
    </PanelCard>
  )
}
